var exports = {
  "EQ": "ProductAnnouncementModalMobile__cnCmPn",
  "M8": "ProductAnnouncementModalMobile__hero-header__7seP-z",
  "FH": "ProductAnnouncementModalMobile__hero-visual__K1j0We",
  "LD": "ProductAnnouncementModalMobile__content__4eVM_-",
  "mg": "ProductAnnouncementModalMobile__content-tabs___CNwV8",
  "gK": "ProductAnnouncementModalMobile__content-seeAll___dLm6D",
  "RR": "ProductAnnouncementModalMobile__ctas__Ew3JpT",
  "QE": "ProductAnnouncementModalMobile__ctas--stacked__qNCvPR",
  "NY": "ProductAnnouncementModalMobile__header__j7DLli",
  "Em": "ProductAnnouncementModalMobile__label__v6GcZb",
  "o7": "ProductAnnouncementModalMobile__body__EPpuTa",
};

module.exports = exports;
